const mask = require('header.mask');
const data = require('header.data');
const $ = require('jquery');
const storeFinderCore = require('header.storeFinder.core');
const config = {
  activeNavigationItemClass: 'NavigationList__item--active',
};

class Dropdown {
  constructor() {
    this.menuConfig = data.getMenuConfig();
    this._toggleMenu = this._toggleMenu.bind(this);
    this._closeMenu = this._closeMenu.bind(this);
    this._closeAllMenus = this._closeAllMenus.bind(this);
    this._closeOnSearchOpen = this._closeOnSearchOpen.bind(this);
    this._breakpointChanged = this._breakpointChanged.bind(this);
    this._setMenuState = this._setMenuState.bind(this);
    this._closeAllMenusAndMask = this._closeAllMenusAndMask.bind(this);
  }

  _setMenuState(menuID, value) {
    if (
      this.menuConfig[menuID] &&
      this.menuConfig[menuID].isActive !== 'undefined'
    ) {
      this.menuConfig[menuID].isActive = value;
    }
  }

  _openMenus(menuID) {
    this._setMenuState(menuID, true);
    if (this.menuConfig[menuID] && this.menuConfig[menuID].name) {
      $('.' + this.menuConfig[menuID].name + '__link--active').removeClass(
        this.menuConfig[menuID].name + '__link--active',
      );

      $(
        '.NavigationList__item__link[data-id="' +
          this.menuConfig[menuID].name +
          '"]',
      )
        .parent('li')
        .addClass(config.activeNavigationItemClass);

      $(
        '.NavigationList__item__link[data-id="' +
          this.menuConfig[menuID].name +
          '"]',
      ).addClass('js__flyout--open');
      $('.' + this.menuConfig[menuID].menuClass).addClass(
        this.menuConfig[menuID].menuClass + '--open',
      );
    }
  }

  _closeMenu(menuID) {
    this._setMenuState(menuID, false);
    $('.NavigationList__item__link[data-id="' + menuID + '"]').off('.flyout');
    $('.MainFlyout')
      .removeClass('MainFlyout--open')
      .removeClass('MainFlyout--panels-3')
      .removeClass('MainFlyout--panels-4')
      .find('.MainFlyout__link')
      .removeClass('MainFlyout__link--active');
    $('.' + this.menuConfig[menuID].menuClass).removeClass(
      this.menuConfig[menuID].menuClass + '--open',
    );
  }

  _closeAllMenus() {
    Object.keys(this.menuConfig).forEach((key) => {
      this._closeMenu(key);
    });
    this._removeHoverIntent('.Header3');
  }

  _closeAllMenusAndMask() {
    this._closeAllMenus();
    mask.show(null, false);
  }

  _toggleMenu(event) {
    if (storeFinderCore.isLocalizationDrawerOpen()) return;

    const menuID = $(event.target).data('id');
    if (menuID) {
      $(document).trigger('closeDrawer');
      $(document).trigger('closeHeaderTooltips');
      /*
        For now, we can comment out the check for whether we're not currently on a third-party page,
        since the B2B Header-Footer only has the All Products flyout anyway.  If we ever add additional
        flyouts, we can remove the comments and perform the check

        (applies to the second identical conditional below)
      */
      if (/* data.isNonThirdPartyPage() && */ menuID === 'departmentsFlyout') {
        event.preventDefault();
        event.stopPropagation();
        $(document).trigger('closeNavLinkDropdowns');
      }
      if (
        this.menuConfig[menuID] &&
        this.menuConfig[menuID].isActive &&
        event.type !== 'mouseover'
      ) {
        this._closeMenu(menuID);
        mask.show(null, false);
      } else {
        this._closeAllMenus();
        this._setMenuState(menuID, true);
        if (
          /* data.isNonThirdPartyPage() && */ menuID === 'departmentsFlyout'
        ) {
          mask.show();
          this._openMenus(menuID);
        }
      }
    } else {
      this._closeAllMenusAndMask();
    }
    // If the navlink in the JSON has a linkDisable property and it is set to True, stop propagation
    const menuDisableLink = $(event.target).data('disablelink');
    if (menuDisableLink) {
      mask.show();
      event.stopPropagation();
    }
    this._closeTypeAhead();
  }

  _removeHoverIntent($element) {
    $($element).off('.hoverIntent');
    return $element;
  }

  _triggerHoverIntent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this,
    });
  }

  _breakpointChanged(event, eventData) {
    if (eventData.channel === 'desktop') {
      $(document).trigger('showSimpleFlyout', false);
    } else {
      this._closeAllMenusAndMask();
    }
  }

  _closeOnSearchOpen(event, isOpen) {
    if (isOpen) {
      this._closeAllMenusAndMask();
    }
  }

  _closeTypeAhead() {
    let isSearchBarFocused = $('#headerSearch').is(':focus');
    if (isSearchBarFocused) {
      $('#headerSearch').blur();
      $('#typeAheadFlyOut').removeClass('typeahead__show');
    }
  }

  init() {
    let triggerHoverIntent = this._triggerHoverIntent;
    $(document)
      .on('closeAllMenus', this._closeAllMenus)
      .on('closeAllMenusAndMask', this._closeAllMenusAndMask)
      .on('breakpointChanged', this._breakpointChanged)
      .on('searchState', this._closeOnSearchOpen)
      .on('click touchend', '.Header3', this._closeAllMenusAndMask)
      .on(
        'click touchend mouseover',
        '.NavigationList__item__link',
        this._toggleMenu,
      )
      .hoverIntent({
        selector: '.Header3 .HeaderLogo',
        over: triggerHoverIntent,
        out: $.noop,
      });
  }
}
module.exports = new Dropdown();
